import ContainerInner from '../../components/ContentContainer/ContainerInner.jsx';
import ProjectCreateEditForm from '../../components/ProjectCreateEditForm/ProjectCreateEditForm.jsx';

function CreateProject() {
  return <ProjectCreateEditForm />;
  // return <ContainerInner title="Создание проекта" />;
}

export default CreateProject;
